(ns frontend.views.retrofit-potential
  "Behaviour for the Retrofit Potential page, whose filters and sort links each
  reload it: a filter applies as soon as it is picked, and a keyboard user keeps
  their place across the reload."
  (:require
   [common.util  :as u]
   [shadow.graft :as graft]))

(def ^:private focus-memo-key "retrofit-potential-focus")

(defn- restore-focus!
  []
  (when-let [id (.getItem js/sessionStorage focus-memo-key)]
    (.removeItem js/sessionStorage focus-memo-key)
    (let [focus! (fn []
                   (some-> (.getElementById js/document id)
                           (.focus #js {:preventScroll true})))]
      (if (= "complete" (.-readyState js/document))
        (focus!)
        (.addEventListener js/window "load" focus! #js {:once true})))))

(defn- remember-focus!
  [^js page keyboard?]
  (let [focused (.-activeElement js/document)]
    (if (and keyboard? (.contains page focused) (seq (.-id focused)))
      (.setItem js/sessionStorage focus-memo-key (.-id focused))
      (.removeItem js/sessionStorage focus-memo-key))))

(defn- reload-keeping-focus
  [^js page]
  (let [keyboard? (atom false)]
    (restore-focus!)
    (.addEventListener js/document "pointerdown" (fn [_] (reset! keyboard? false)))
    (.addEventListener js/document "keydown" (fn [_] (reset! keyboard? true)))
    (.addEventListener page "change" (fn [^js event] (.requestSubmit (.. event -target -form))))
    (.addEventListener js/window "pagehide" (fn [_] (remember-focus! page @keyboard?)))))

(defmethod graft/scion (u/->scion-id :frontend.views.retrofit-potential/reload-keeping-focus)
  [_params page]
  (reload-keeping-focus page))
